import React from 'react';
import {Redirect} from 'react-router-dom';
import LeftMenu from './LeftMenu';
import RightContentHeader from './RightContentHeader';
import OverviewContainer from '../overview/OverviewContainer';
import VignetContainer from '../vignets/VignetContainer';
import VignetDetailContainer from '../vignets/DetailContainer';

import GraphicsContainer from '../gallery/GraphicsContainer';
import PlaylistContainer from '../playlist/PlaylistContainer';
import PlaylistDetailContainer from '../playlist/DetailContainer';
import UserContainer from '../user/UserContainer';
import FilterBar from "./FilterBar";
import HeaderBar from "./HeaderBar";


import * as playlistActions from "../../actions/playlist";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as vignetsActions from "../../actions/vignets";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form , FormGroup, Label, Input, FormFeedback} from 'reactstrap';
import AuthService from '../../lib/AuthService';



class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value:'',
            showModal: false,
            showModal1: false,
            error_message:'',
            pl_name: '',
            wrapClass : 'right-bottom-area ',
            addVigToPl : false,
            detUrl : ''

        };
        this.Auth = new AuthService();
        this.toggle = this.toggle.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.renderContainer = this.renderContainer.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.savePlaylist = this.savePlaylist.bind(this);
    }

    componentDidMount() {
        if(this.props.pageName === 'PLAYLIST') {
            this.setState({
                wrapClass: 'right-bottom-area no-overflow'
            });
        }

        if( this.props.match.path === "/playlist/add/:id") {
            this.setState({ addVigToPl: true});
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if( prevProps.playlistData.playlistUpdated !== this.props.playlistData.playlistUpdated && this.props.match.path === "/playlist/add/:id") {
            this.setState({nextUrl : "/playlist/"+this.props.match.params.id });
        }
    }

    toggle() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    mToggle() {
        this.setState({
            showModal1: !this.state.showModal1
        });
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    renderContainer() {
        switch(this.props.pageName) {
            case 'OVERVIEW':
                return <OverviewContainer />;
            case 'VIGNETS':
                return <VignetContainer />;
            case 'VIGDETAIL':
                return <VignetDetailContainer />;
            case 'MY_UPLOADS':
                return <GraphicsContainer />;
            case 'AUDIO':
                return <GraphicsContainer />;
            case 'VIDEO':
                return <GraphicsContainer/>;
            case 'PLAYLIST':
                return <PlaylistContainer  showPlaylist={true} showVignets={false} showEdit={false}/>
            case 'PLAYLISTDETAIL':
                return <PlaylistDetailContainer />;
            case 'USER':
                return <UserContainer />;
            default:
                return <VignetContainer />;
        }
    }

    savePlaylist() {
        let vigSelectCount = this.props.vignetsData.selected_ids.length;

        let error = '';

        if(vigSelectCount === 0) {
            error = "Select atleast a vignet to proceed";
        }
        else if(this.state.pl_name === '') {
            error = "Please enter  a playlist name to proceed";
        }
        else {
            error = "";
            var vigIds = this.props.vignetsData.selected_ids;

            var data = {pl_name : this.state.pl_name, vigIds: vigIds, userid : this.Auth.getProfile().user_id};

            console.log(data);
            this.props.createPlaylist(data);

            this.mToggle();

        }

        this.setState({error_message: error});
    }

    addToPlaylist() {
        let data = {plid :  this.props.match.params.id , vigids : this.props.vignetsData.selected_ids}
        this.props.addItemToPlaylist(data);
    }


    render() {

        if(this.state.nextUrl){
            return <Redirect exact to={this.state.nextUrl} />
        }



        return (
            <div className="wrapper">
                <HeaderBar />
                <section className="content-area inner-skew">
                    <div className="conten-wrapper">
                        <LeftMenu pageName={this.props.pageName} />

                        <div className="right-content-area">

                            <RightContentHeader pageName={this.props.pageName}  />

                            <div className={this.state.wrapClass}>
                                {this.props.pageName !== 'VIGDETAIL' && this.props.pageName !== 'OVERVIEW' && this.props.pageName !== 'PLAYLISTDETAIL'  &&
                                <FilterBar pageName={this.props.pageName}/>
                                }

                                {this.renderContainer()}


                                <Modal isOpen={this.state.showModal} toggle={this.toggle} >
                                    <ModalBody>
                                        <div className="alert alert-danger text-center" role="alert">
                                            Please select atleast a vignet to proceed.
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="secondary" onClick={this.toggle}>Close</Button>
                                    </ModalFooter>
                                </Modal>


                                <Modal isOpen={this.state.showModal1} toggle={this.mToggle} centered={true} className="vig-mod">
                                    <ModalHeader className="vignet-header" toggle={this.mToggle}>Create Playlist</ModalHeader>
                                    <ModalBody>
                                        {this.state.error_message !== '' &&
                                        <div className="alert alert-danger hide" id="pl-error" role="alert">
                                            {this.state.error_message}
                                        </div>
                                        }
                                        <div className="form_container">


                                            <Form method="POST" >
                                                <FormGroup>
                                                    <Label for="exampleEmail">Enter Playlist Name</Label>
                                                    <Input type="text" name="pl_name" id="pl_name" placeholder="Playlist Name" className={this.state.pl_name_class} onChange={this.handleInputChange} valid={false} />
                                                    <FormFeedback className={this.state.pl_name_class}  tooltip> Please enter a playlist name</FormFeedback>
                                                </FormGroup>


                                            </Form>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <FormGroup className="pull-right button-gp">
                                            <Button name="submit_form" type="button" color="info" className="save_btn" onClick={()=> this.savePlaylist()}>Save</Button>
                                            <Button name="build_vignet" type="button" color="success" onClick={this.mToggle}>Cancel</Button>
                                        </FormGroup>
                                    </ModalFooter>
                                </Modal>
                            </div>
                            {this.state.addVigToPl &&
                            <div className="pl-msg-wrap">
                                <div className="pl-msg-l">
                                    <span className="pl-msg">Start adding Vignets to New Playlist</span>
                                    <span className="pl-msg">Selected Vignets: {this.props.vignetsData? this.props.vignetsData.selected_ids.length: 0}</span>
                                </div>
                                <div className="pl-msg-r">
                                    <button name="done_btn" className="btn" onClick={() => {this.addToPlaylist()}}>DONE</button>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        vignetsData  : state.vignets.vignetsData,
        playlistData  : state.playlist.playlistData
    };

}

export default  withRouter(connect(mapStateToProps, {
    removeVignets : vignetsActions.deleteVignets,
    createPlaylist : playlistActions.createPlaylist,
    addItemToPlaylist : playlistActions.addToPlaylist
})(MainLayout, PlaylistContainer));



// WEBPACK FOOTER //
// ./src/components/common/MainLayout.js